import {
    EnumWorkflowRunStatus,
    getBadgeVariantByWorkflowRunStatus,
    getEnumWorkflowRunStatusLabel,
    type ApiWorkflowRun,
} from '@Model';
import { workflowTitleOf } from '@Modules/AgenticOrchestrator/workflowTools';
import { Badge, Column } from '@synqo/frontend-component-library';

export const workflowRunColumns: Column<ApiWorkflowRun>[] = [
    { name: 'created_at', label: 'Zeitpunkt', type: 'datetime' },
    {
        name: 'definition_key',
        label: 'Workflow',
        renderCell: ({ cellData }) => workflowTitleOf(cellData as string),
    },
    {
        name: 'run_status',
        label: 'Status',
        renderCell: ({ cellData }) => {
            const status = cellData as EnumWorkflowRunStatus;
            return (
                <Badge variant={getBadgeVariantByWorkflowRunStatus(status)}>
                    {getEnumWorkflowRunStatusLabel(status)}
                </Badge>
            );
        },
    },
    { name: 'finished_at', label: 'Ende', type: 'datetime' },
];
